import z from 'zod';

export const DiscountTypeSchema = z.enum([ 'PERCENTAGE', 'FIXED_AMOUNT' ]);
export type DiscountTypeType = `${z.infer<typeof DiscountTypeSchema>}`;
export const ConditionTypeSchema = z.enum([ 'BIRTHDAY', 'FIRST_ORDER', 'NONE' ]);
export type ConditionTypeType = `${z.infer<typeof ConditionTypeSchema>}`;

export const PromotionSchema = z.object({
	type:          DiscountTypeSchema,
	conditionType: ConditionTypeSchema,
	id:            z.string().uuid(),
	createdAt:     z.coerce.date(),
	updatedAt:     z.coerce.date(),
	name:          z.string(),
	description:   z.string().nullable(),
	startDate:     z.coerce.date(),
	endDate:       z.coerce.date(),
	quota:         z.number().int(),
	isActive:      z.boolean(),
	value:         z.number(),
	minimumSpend:  z.number(),
});

export type Promotion = z.infer<typeof PromotionSchema> & {
	appliedAmount: number;
};